import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { handleError, isNotBusinessError } from '../../../utils/handleError';
import { AlertError } from '../../../components/bootstrap/AlertError';
import { Arrays } from '../../../utils/Arrays';
import { FormattedMessage, useIntl } from 'react-intl';
import { EnumSelectField } from '../../../components/bootstrap/EnumSelectField';
import { AlertSuccess } from '../../../components/bootstrap/AlertSuccess';
import { useNavigate } from 'react-router-dom';
import { LabelToolTip } from '../../../components/bootstrap/LabelToolTip';
import { EmptyResults } from '../../../components/general/EmptyResults';
import { SubTemplate } from '../../../components/general/SubTemplate';
import Loading from '../../../components/general/Loading';
import { CustomPagination } from '../../../components/general/CustomPagination';
import { listPriorSupportPaymentRequest, priorSupportPaymentRequestFormStatus } from '../../../rest/priorSupportPaymentRequest';
import { ListFilterBar } from '../../../components/general/ListFilterBar';
import { ProcessState } from '../../../models/ProcessState';
import { economicViabilityPaymentRequestFormStatus, listEconomicViabilityPaymentRequest } from '../../../rest/economicViabilityPaymentRequest';
import { useLocation } from "react-router";

const MAX_RESULTS = 10;
const DEFAULT_INITIAL_PAGE = 0;

export function ListEconomicViabilityPaymentRequest() {
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [numberOfResults, setNumberOfResults] = useState(null);
	const [totalResults, setTotalResults] = useState(null);

	const [b5List, setB5List] = useState([]);

	const orderByOptionsIdPrefix = 'economicViabilityPaymentRequest.list.orderOption';
	const orderByOptions = ['changeDate_desc', 'changeDate_asc'];

	const [currentOrderBy, setCurrentOrderBy] = useState(orderByOptions[0]);

	const { search } = useLocation();
	const params = new URLSearchParams(search);
	const [currentPage, setCurrentPage] = useState(params.get('page')!==null && params.get('page')!==DEFAULT_INITIAL_PAGE ? Number(params.get('page')) : DEFAULT_INITIAL_PAGE);
	const [filters, setFilters] = useState({
		state: {
			type: 'enum',
			preffixDescriptionId: 'processState',
			options: ProcessState.values(),
			value: params.get('state')!==null && params.get('state')!=-'1' ? params.get('state')  : '-1',
			nullOption: true,
			nullOptionSuffix: 'state',
			colSpace: 3,
		},
	});

	const hoverpreffixId = 'economicViabilityPaymentRequest.list.hover';

	const [statusFormB5, setStatusFormB5] = useState(null);

	const navigate = useNavigate();

	const intl = useIntl();

	const [lsItem, setLsItem] = useState(null);

	function handleSearch(fromFilter) {
		const history = window.history;


		let currentUrlParams = new URLSearchParams(window.location.search);
		if(filters.state.value!== null && filters.state.value!== '-1'){
			currentUrlParams.set('state',filters.state.value);
		}else{
			currentUrlParams.delete('state')
		}

		const url = currentUrlParams.size==0 ? window.location.pathname : window.location.pathname + '?' + currentUrlParams.toString();
		history.replaceState({}, '', url);
		fetchData(fromFilter);
	}

	async function fetchData(fromFilter) {
		try {
			if(fromFilter === true){
				setCurrentPage(0);
			}

			let orderParams = currentOrderBy.split('_');

			let queryparams = {
				index: fromFilter ? 0 : currentPage,
				size: MAX_RESULTS,
				orderBy: orderParams[0],
				orderType: orderParams[1],
			};

			if (filters.state.value !== '-1') {
				queryparams.state = filters.state.value;
			}

			const [{ data: formList }] = await Promise.all([
				await listEconomicViabilityPaymentRequest(queryparams),
			]);

			setB5List(formList.results);
			setNumberOfResults(formList.numberOfResults);
			setTotalResults(formList.totalResults);
		} catch (error) {
			setError(error);
		} finally {
			setLoading(false);
		}
	}

	const onPageChange = (pageNumber) => {
		setCurrentPage(pageNumber);
	};

	function handleOrderByChange(e) {
		setCurrentOrderBy(e.target.value);
	}

	async function getB5FormStatus() {
		const { data: status } = await economicViabilityPaymentRequestFormStatus();
		setStatusFormB5(status);
	}

	useEffect(() => {
		checkStorageItems();
		getB5FormStatus();
	}, []);

	useEffect(() => {
		const history = window.history;
		let currentUrlParams = new URLSearchParams(window.location.search);
		if(currentPage!== null && currentPage!== DEFAULT_INITIAL_PAGE){
			currentUrlParams.set('page',currentPage);
		}else{
			currentUrlParams.delete('page')
		}
		console.log(currentUrlParams);
		const url = currentUrlParams.size===0 ? window.location.pathname : window.location.pathname + '?' + currentUrlParams.toString();
		history.replaceState({}, '', url);
		
		fetchData();
	}, [currentPage]);

	if (loading) {
		return <Loading />;
	}

	if (error && isNotBusinessError(error)) {
		return handleError(error);
	}

	function redirectToFormPage(b5ExternalId) {
		navigate(
			`/pagamento/viabilidadeEconomica/${b5ExternalId !== undefined ? b5ExternalId : ''}`
		);
	}

	function checkStorageItems() {
		if (sessionStorage.getItem('economicViabilityRequestSubmited')) {
			setLsItem('economicViabilityRequestSubmited');
		}
		if (sessionStorage.getItem('economicViabilityPaymentRequestWithdrawed')) {
			setLsItem('economicViabilityPaymentRequestWithdrawed');
		}
		if (sessionStorage.getItem('economicViabilityPaymentRequestAnnulled')) {
			setLsItem('economicViabilityPaymentRequestAnnulled');
		}
	}

	return (
		<SubTemplate
			titleId={'economicViabilityPaymentRequest.list.title'}
			hasBackButton
		>
			<Container>
				<div className='mx-2 mb-4'>
					<AlertSuccess lsItem={lsItem} />
				</div>
				<Row>
					<Col md='10'>
						<ListFilterBar
							filters={filters}
							setFilters={setFilters}
							search={handleSearch}
						/>
					</Col>
				</Row>
				<Row className='searchResults'>
					<Col md='10'>
						<AlertError error={error} />

						{Arrays.isNotEmpty(b5List) ? (
							<>
								<Row className='mt-5 mb-1 d-flex justify-content-between px-2'>
									<Col className='text-muted'>
										{totalResults}{' '}
										<FormattedMessage
											id={`list.header.requests.${
												totalResults === 1 ? 'singular' : 'plural'
											}`}
										/>
									</Col>
									<Col md='4'>
										<EnumSelectField
											preffixDescriptionId={orderByOptionsIdPrefix}
											handleChange={handleOrderByChange}
											options={orderByOptions}
											value={currentOrderBy}
										/>
									</Col>
								</Row>

								<ul className='results'>
									{b5List.map((b5, index) => (
										<li key={b5.externalId}>
											<Row
												className='py-3'
												onClick={() => redirectToFormPage(b5.externalId)}
											>
												<Col md='7' className='d-flex align-items-center'>
													<LabelToolTip
														labelId={`${hoverpreffixId}.request`}
														value={
															intl.formatMessage({
																id: 'economicViabilityPaymentRequest.title',
															})
														}
													/>
												</Col>
												<Col md='2' className='d-flex align-items-center'>
													<LabelToolTip
														labelId={`${hoverpreffixId}.state`}
														value={
															<FormattedMessage
																id={`processState.${b5.processState}`}
															/>
														}
													/>
												</Col>
												<Col
													md='3'
													className='d-flex align-items-center justify-content-end'
												>
													<LabelToolTip
														labelId={`${hoverpreffixId}.changeDate`}
														value={b5.changeDate}
													/>
												</Col>
											</Row>
										</li>
									))}
								</ul>
							</>
						) : (
							<EmptyResults />
						)}
					</Col>
					{statusFormB5 !== null && statusFormB5.canFill && (
						<Col md='2'>
							<div className='mt-4 py-3'>
								<button
									className='btn btn-outline-primary d-flex align-items-center justify-content-center mb-4 w-100'
									type='button'
									onClick={() => redirectToFormPage()}
								>
									<FormattedMessage id={`annualComplementaryActivitiesPayment.button.${statusFormB5.inDraft ? 'continue' : 'create'}`} />
								</button>
							</div>
						</Col>
					)}
				</Row>
				<Row className='mb-5'>
					<Col md='10' className='d-flex'>
						<div className='mx-2'>
							<CustomPagination
								dataPerPage={MAX_RESULTS}
								totalData={totalResults}
								onPageChange={onPageChange}
								currentPage={currentPage}
							/>
						</div>
					</Col>
				</Row>
			</Container>
		</SubTemplate>
	);
}
